/**
 * Logout confirmation modal component.
 */

import { Modal, Button, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';

interface LogoutModalProps {
  show: boolean;
  onHide: () => void;
}

export default function LogoutModal({ show, onHide }: LogoutModalProps) {
  const { logout } = useAuth();
  const { t } = useTranslation();

  const handleConfirmLogout = async () => {
    await logout();
    onHide();
    // Use window.location.href for a full page redirect to ensure clean state
    window.location.href = '/login';
  };

  return (
    <Modal show={show} onHide={onHide} centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{t('modals.logout.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-0">
          {t('modals.logout.message')}
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className="me-2">
          {t('modals.logout.cancel')}
        </Button>
        <Button variant="danger" onClick={handleConfirmLogout}>
          {t('modals.logout.confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
